import React, { useEffect, useState, useMemo } from 'react'
import VisDiv from '../../whitaijiFrontendLibrary/components/VisDiv'
import BlueButton from '../BlueButton'
import { CheckButton } from './materials/CheckButton'

const MultipleChoices = ({data={}}) => {
  const {doc, setDoc, answerOptions} = data

  const question = useMemo(() => ({ questionId: data?._id }), [data]);

  const [userResponse, setUserResponse] = useState()

  const testFunction = () => {
    process.env.NODE_ENV === "development" && console.log("doc", doc, "userResponse", userResponse)
    
  }

  useEffect(()=>{
    const initialUserResponse = doc?.userResponses?.find((item)=>item?.questionId === question?.questionId)
    //process.env.NODE_ENV === "development" && console.log("initialUserResponse", initialUserResponse)
    setUserResponse(initialUserResponse)
  }, [doc, question])

  const dataToAllComponents = {userResponse, setUserResponse, doc, setDoc, question}

  return (
    <div className='answer-container'>
    <BlueButton fn={testFunction} hide={true} text={"Test One Choice"} />
    {/* <h3 className='margin-bottom'>{question?.title}{question?.required && "*"}</h3> */}
    <VisDiv rules={[answerOptions, answerOptions?.length > 0]} >
        {answerOptions?.map((item, index)=> {
          if(!item) return null
          return ( 
            <div key={item?.answerId ? item?.answerId : index} >
              <CheckButton data={{...dataToAllComponents, ...item}} > {item?.answerText} </CheckButton>
            </div>
        )})}
      </VisDiv>
    </div>
  )
}

export default MultipleChoices
